export const GDPR_SETTINGS_ANCHOR = 'settings'

export const COOKIES_TRACKING_PREFIX = 'CMP'

export const COOKIES_TRACKING_NAME = {
  ACCEPT: 'accept',
  BANNER: 'v1',
  BACK: 'back',
  INFO: 'more_information',
  MODAL: 'v2',
  MODAL_STEP: 'step',
  REFUSE: 'refuse',
  SAVE: 'save_settings',
  SETTINGS: 'settings',
  TOGGLE: 'toggle',
}
